import type { components } from '@/types/apiSchema';

export type JobState = Exclude<components['schemas']['JobState'], null>;

interface JobStateMeta {
  description: string;
  hiringManagerVisible: boolean;
  label: string;
  value: JobState;
}

export const jobStateOptions: JobStateMeta[] = [
  {
    value: 'Published',
    label: 'Published',
    description: 'Visible to hiring managers and sends Slack notifications.',
    hiringManagerVisible: true,
  },
  {
    value: 'Unpublished',
    label: 'Unpublished',
    description: 'Hidden from hiring managers until published.',
    hiringManagerVisible: false,
  },
  {
    value: 'OnHold',
    label: 'On hold',
    description:
      'Visible to hiring managers, but Slack notifications are muted.',
    hiringManagerVisible: true,
  },
  {
    value: 'Hired',
    label: 'Hired',
    description:
      'Hiring for this role is complete, not visible to hiring managers, no Slack notifications.',
    hiringManagerVisible: false,
  },
  {
    value: 'Closed',
    label: 'Closed',
    description:
      'This role has been closed and is no longer active, not visible to hiring managers, no Slack notifications.',
    hiringManagerVisible: false,
  },
];

export const parseJobState = (value: string | null): JobState | undefined => {
  return jobStateOptions.find((option) => option.value === value)?.value;
};

export const getJobStateMeta = (state: components['schemas']['JobState']) => {
  if (!state) {
    return null;
  }

  return jobStateOptions.find((option) => option.value === state) ?? null;
};

export const isJobVisibleToHiringManagers = (
  state: components['schemas']['JobState'],
) => {
  return getJobStateMeta(state)?.hiringManagerVisible ?? false;
};
